import React, { useState, useEffect } from "react";
import PersonalInfo from "./Personalinfo";
// import Select from "react-select";
import { DatePickerInput } from "rc-datepicker";
import "rc-datepicker/lib/style.css";
import IbanFeild from "../../Atoms/IbanFeild";
import IBAN from "../../Atoms/IBAN";
import RequiredFeild from "../../Atoms/RequiredFeild";
import { NavLink, useNavigate } from "react-router-dom";
import PostData from "../../../Api/PostData";
import axios from "axios";
import Swal from 'sweetalert2'
import './style.css'
import { Select, Radio, Form, Tooltip, Button, Divider } from 'antd';
import analytics from '../../../firebase.config'
import { getAnalytics, logEvent } from "firebase/analytics";
import Disclaimer from "../../Atoms/Disclaimer";
const { Option, OptGroup } = Select;



function useRunAfterUpdate() {
  const afterPaintRef = React.useRef(null);
  React.useLayoutEffect(() => {
    if (afterPaintRef.current) {
      afterPaintRef.current();
      afterPaintRef.current = null;
    }
  });
  const runAfterUpdate = fn => (afterPaintRef.current = fn);
  return runAfterUpdate;
}


const IDVerification = ({
  handleDrctChange,
  prevStep,
  nextStep,
  handleChange,
  values,
}) => {
  const [sendingSaveReq, setsendingSaveReq] = useState(false);
  const [ibanMatchBank, setIbanMatchBank] = useState([]);
  // const [showOtherBankFeild, setOtherBankFeild] = useState(false);
  // const [showBankFeild, setShowBankFeild] = useState(false);
  const [backAndContinueBtnStatus, setBackAndContinueBtnStatus] = useState(false);
  const [error, setError] = useState(false);
  const runAfterUpdate = useRunAfterUpdate();
  const [errorMessage, setErrorMessage] = useState(false);
  var ProofRelationFileName1;
  var PermanentProofRelationFileparam;
  var MailingProofRelationFileparam;
  var ProofRelationFileUnCompressedvar;
  var remitanceValue;
  var remitanceName;
  var signedEmail = JSON.parse(localStorage.getItem("user")).email;
  var moveToOtpScreenOtpRejected = localStorage.getItem("editFormStatusForReturnOnOtp")
  var editFormStatus = localStorage.getItem("editFormStatus");
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const handleCDCLink = () => {
    // window.location.href = 'https://www.cdcpakistan.com/about-us/cdc-access/'
    window.open('https://www.cdcpakistan.com/about-us/cdc-access/', '_blank').focus();


  }





  const onHandleChange = (e) => {

    const input = e.target;
    let ibanwithspace = e.target.value.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim()

    if (e.target.name == "IBAN") {

      if (input.value.length > 9) {
        let ibanCode = ibanwithspace?.substring(5, 9)

        const nam = BankCodeDetail.filter(obj => obj.Bank_Code == ibanCode)

        if (nam.length > 0) {


          handleDrctChange("BankName", nam[0]?.Nccl_value)
          handleDrctChange("showBankFeild", true)
          handleDrctChange("showOtherBankFeild", false)

        }
        else {

          handleDrctChange("BankName", '')

          handleDrctChange("showBankFeild", false)

          handleDrctChange("showOtherBankFeild", true)

        }
      }
      else {
        handleDrctChange("BankName", '')

        handleDrctChange("showBankFeild", false)

        handleDrctChange("showOtherBankFeild", false)
      }
    }


    // if (e.target.name == "IBAN") {

    //   if (input.value.length > 9) {
    //     let ibanCode = e.target.value.substring(5, 9)

    //     const nam = BankCodeDetail.filter(obj => obj.Bank_Code == ibanCode)
    //     if (nam.length > 0) {
    //       handleDrctChange("BankName", nam[0]?.Nccl_value)

    //       handleDrctChange("showBankFeild", true)
    //     }
    //     else {
    //       handleDrctChange("BankName", '')

    //       handleDrctChange("showBankFeild", false)
    //     }
    //   }
    // }

    var position = input.selectionEnd, length = input.value.length;
    // const text = input.value.replace(/[A-Za-z]/gi, "").replace(/(.{4})/g, '$1 ').trim();
    const text = input.value.toUpperCase().replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();

    const cursor = position += ((text.charAt(position - 1) === ' ' && text.charAt(length - 1) === ' ' && length !== text.length) ? 1 : 0);
    handleChange(e)
    runAfterUpdate(() => {
      input.selectionStart = cursor;
      input.selectionEnd = cursor;
    });
  }




  const onChangeDate = (event, name, minDate, maxDate) => {
    let dateConvert = convert(event);
    handleDrctChange(name, dateConvert);
  };
  const textareaRef = React.useRef();
  const cursorPosition = 5;

  const history = useNavigate();

  const convert = (str) => {
    var date = new Date(str),
      mnth = date.toLocaleString("default", { month: "short" }),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
  };

  const IDType = [
    { value: "CNIC", label: "CNIC (country of stay is Pakistan)" },
    { value: "SNIC", label: "SNIC (with chip & country of stay is Pakistan)" },
  ];

  const IDTypeNonResident = [
    { value: "NICOP", label: "NICOP (country of stay is another country)" },
    { value: "POC", label: "POC (Pakistan Origin Card)" },

  ];

  const Occupations = [
    { value: "P001", label: "Agriculturist" },
    { value: "P002", label: "Business" },
    { value: "P003", label: "Business Executive" },
    { value: "P005", label: "House Hold" },
    { value: "P006", label: "House Wife" },
    { value: "P007", label: "Industrialist" },
    { value: "P012", label: "Professional" },
    { value: "P013", label: "Retired Person" },
    { value: "P014", label: "Service" },
    { value: "P015", label: "Student" },
    { value: "P019", label: "Govt / Public Sector" },
    { value: "P999", label: "Other" },
  ];

  const BasisOfRemittance = [
    { value: "1", label: "Yes, I'll do this (Repatriable)" },
    { value: "2", label: "No, I won't do this (Non-Repatriable)" },
    // { value: "7", label: "Resident Pakistani " }
  ]
  const AnualIncomes = [
    // { value: "J07", label: "100,000 - 250,001" },
    // { value: "J08", label: "250,000 - 500,000" },
    // { value: "J09", label: "500,000 - 1,000,000" },
    // { value: "J10", label: "1,000,000 & Above" },
    { value: "J07", label: "Up to 100,000" },
    { value: "J08", label: "100,001 - 250,000" },
    { value: "J09", label: "250,001 - 500,000" },
    { value: "J10", label: "Above 500,000" },
  ];
  const AnualIncomesNormal = [
    { value: "J01", label: "Up to 100,000" },
    { value: "J02", label: "100,001 - 250,000" },
    { value: "J03", label: "250,001 - 500,000" },
    { value: "J04", label: "500,001 - 1,000,000" },
    { value: "J05", label: "1,000,001 - 2,500,000" },
    { value: "J06", label: "Above 2,500,000" },
  ];
  const Zakat = [
    { value: "5", label: "Yes, allow Zakat deductions" },
    { value: "6", label: "No, don't allow Zakat deductions" },
    { value: "7", label: "No, this doesn't apply to me (I'm not Muslim)" },
  ];
  const EWalletProvider = [
    { value: "1", label: "Askari Digital Wallet" },
    { value: "2", label: "Upaisa" },
    { value: "3", label: "Zindigi" },
    { value: "4", label: "JazzCash" },
    { value: "5", label: "SADAPAY" },
    { value: "6", label: "NAYAPAY" },
    { value: "7", label: "UBL Digital Wallet" },
    { value: "8", label: "Easypaisa" },
    { value: "9", label: "Bank Aflalah Walle" },
    { value: "10", label: "HBL Kconnect" },
    { value: "11", label: "OTHERS" },
  ];


  const BankCodeDetail = [
    { Bank_Code: "AIIN", label: "Al Baraka Bank", Nccl_value: "Al-Baraka Bank (Pakistan) Limited" },
    { Bank_Code: "ABPA", label: "Allied Bank", Nccl_value: "Allied Bank limited" },
    { Bank_Code: "ASCM", label: "Askari Bank", Nccl_value: "Askari Bank Limited" },
    { Bank_Code: "BAHL", label: "AL Habib", Nccl_value: "Bank Al-Habib Limited" },
    { Bank_Code: "ALFH", label: "Bank Alfalah", Nccl_value: "Bank Al-Falah Limited" },
    { Bank_Code: "BKCH", label: "Bank of China", Nccl_value: "Bank of China Limited" },
    { Bank_Code: "KHYB", label: "The Bank of Khyber", Nccl_value: "The Bank of Khyber" },
    { Bank_Code: "BKIP", label: "BankIslami", Nccl_value: "Bank Islami Pakistan Limited" },
    { Bank_Code: "CITI", label: "Citibank", Nccl_value: "Citi Bank N.A." },
    { Bank_Code: "DEUT", label: "Deutsche Bank", Nccl_value: "Deutsche Bank AG" },

    { Bank_Code: "DUIB", label: "Dubai Islamic Bank Pakistan (DIB)", Nccl_value: "Dubai Islamic Bank Pakistan" },
    { Bank_Code: "FAYS", label: "Faysal Bank", Nccl_value: "Faysal Bank Limited" },
    { Bank_Code: "FWOM", label: "First Women Bank Ltd.", Nccl_value: "First Women Bank Limited" },
    { Bank_Code: "HABB", label: "HBL", Nccl_value: "Habib Bank Limited" },
    { Bank_Code: "MPBL", label: "Habib Metropolitan Bank", Nccl_value: "Habib Metropolitan Bank Limited" },
    { Bank_Code: "ICBK", label: "Industrial & Commercial Bank of China (ICBC)", Nccl_value: "Industrial & Commercial Bank of China" },
    { Bank_Code: "JSBL", label: "	JS Bank", Nccl_value: "JS Bank Limited" },
    { Bank_Code: "MUCB", label: "MCB Bank", Nccl_value: "MCB Bank Limited" },
    { Bank_Code: "MCIB", label: "MCB Islamic Bank", Nccl_value: "MCB Islamic Bank Limited" },
    { Bank_Code: "MEZN", label: "Meezan Bank", Nccl_value: "Meezan Bank Limited" },
    { Bank_Code: "NBPA", label: "National Bank of Pakistan (NBP)", Nccl_value: "National Bank of Pakistan" },
    { Bank_Code: "SAMB", label: "Samba Bank", Nccl_value: "Samba Bank Limited" },
    { Bank_Code: "SAUD", label: "Silkbank", Nccl_value: "SILKBANK Limited" },
    { Bank_Code: "SIND", label: "Soneri Bank", Nccl_value: "Soneri Bank Limited" },
    { Bank_Code: "SCBL", label: "Standard Chartered", Nccl_value: "Standard Chartered Bank (Pakistan)" },
    { Bank_Code: "SBPP", label: "State Bank of Pakistan", Nccl_value: "State Bank of Pakistan" },
    { Bank_Code: "SUMB", label: "Summit Bank", Nccl_value: "Summit Bank Limited" },
    { Bank_Code: "BPUN", label: "The Bank of Punjab", Nccl_value: "The Bank of Punjab" },
    { Bank_Code: "TIBL", label: "Trust Investment Bank", Nccl_value: "Trust Investment Bank" },
    { Bank_Code: "UNIL", label: "UBL", Nccl_value: "United Bank Limited" },
    { Bank_Code: "SMES", label: "SME Bank", Nccl_value: "SME Bank Limited" },
    { Bank_Code: "ZTBL", label: "Zarai Tarqiati Bank Limited (ZTBL)", Nccl_value: "Zarai Tarqiati Bank Limited" },


  ]

  const Bank = [
    { value: "1", label: " Habib Bank Limited" },
    { value: "2", label: "United Bank Limited" },
    { value: "3", label: "MCB Bank Limited" },
    { value: "4", label: "Allied Bank limited" },
    { value: "5", label: "Bank Al-Falah Limited" },
    { value: "6", label: "Bank Al-Habib Limited" },
    { value: "7", label: "Habib Metropolitan Bank Limited" },
    { value: "8", label: "JS Bank Limited" },
    { value: "9", label: "Faysal Bank Limited" },
    { value: "10", label: "Askari Bank Limited" },
    { value: "11", label: "Standard Chartered Bank (Pakistan) Limited" },
    { value: "12", label: "Soneri Bank Limited" },
    { value: "13", label: "SILKBANK Limited" },
    { value: "14", label: "Summit Bank Limited" },
    { value: "15", label: "Samba Bank Limited" },
    { value: "16", label: "Meezan Bank Limited" },
    { value: "17", label: "Al-Baraka Bank (Pakistan) Limited" },
    { value: "18", label: "Bank Islami Pakistan Limited" },
    { value: "19", label: "MCB Islamic Bank Limited" },
    { value: "20", label: "Dubai Islamic Bank Pakistan" },
  ];
  const hndlChng = (e) => {

    handleDrctChange("IBAN", e);
  };
  const openSaveExitModel = () => {
    Swal.fire({
      title: 'You’re almost there!',
      text: "Are you sure you want to exit the account opening form? It only takes a couple of minutes to finish.",
      icon: 'success',
      showCancelButton: true,
      confirmButtonColor: '#e5386a',
      // cancelButtonColor: '#d33',
      cancelButtonText: "Continue",
      // showDenyButton: true,
      // showCancelButton: true,
      confirmButtonText: 'Exit',
      // denyButtonText: `Don't save`,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      }
    }).then((result) => {

      if (result.isConfirmed == true) {

        if (moveToOtpScreenOtpRejected == 'true' || editFormStatus == 'true') {
          history("/Otp");
        }
        else {
          history("/");
        }

      }

    })
    // Get the modal
    // var modal = document.getElementById("SaveExitModal");

    // // Get the <span> element that closes the modal
    // var span = document.getElementsByClassName("close");
    // // When the user clicks the button, open the modal
    // modal.style.display = "block";

    // // When the user clicks on <span> (x) or Close, close the modal

    // for (let i = 0; i < span.length; i++) {
    //   console.log(span, span[i]);
    //   span[i].onclick = function () {
    //     modal.style.display = "none";
    //   };
    // }
    // // When the user clicks anywhere outside of the modal, close it
    // window.onclick = function (event) {


    //   if (event.target == modal) {
    //     logout()
    //     modal.style.display = "none";

    //   }
    // };
  };

  const logout = () => {

    localStorage.clear();
    history("/");
    // modal.style.display = "none";
  }

  const SaveSubmit = () => {

    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }


    setsendingSaveReq(true)








    // if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

    //   let fileData = [
    //     values.ProofRelationFile,

    //     values?.PermanentProofRelationFile,
    //     values?.MailingProofRelationFile

    //   ]

    //   let fileResponse

    //   let counter = 0

    //   fileData.forEach((element, index) => {
    //     fileResponse = PostData.FileAndImageUpload(element, setError, true);
    //     fileResponse.then((value) => {
    //       console.log('save file is=========>>', value)

    //       let promise = new Promise((resolve, reject) => {


    //         if (index == 0) {
    //           ProofRelationFileName1 = value?.data?.fileName
    //           counter += 1;
    //         }
    //         else if (index == 1) {
    //           PermanentProofRelationFileparam = value?.data?.fileName
    //           counter += 1;

    //         }
    //         else if (index == 2) {
    //           MailingProofRelationFileparam = value?.data?.fileName
    //           counter += 1;
    //         }


    //         if (counter == 3) {
    //           resolve('success')
    //         }
    //       })
    //       promise.then(data => {
    //         if (data) {
    //           submitForm()
    //         }
    //       })


    //     })

    //   })


    // }

    if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

      let fileData = [
        values.ProofRelationFile,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed

      ]

      let fileResponse

      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {
          console.log('save file is=========>>', value)

          let promise = new Promise((resolve, reject) => {


            if (index == 0) {
              ProofRelationFileName1 = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;

            }


            if (counter == 4) {
              resolve('success')
            }
          })
          promise.then(data => {
            if (data) {
              submitForm()
            }
          })


        })

      })


    }

    else {
      submitForm()
    }






  };
  const SaveOnBackSubmit = (e, paramval) => {
    e.preventDefault()
    logEvent(analytics, 'aof_income_det_press_back');
    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    handleDrctChange('step', 2)

    // if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

    //   let fileData = [
    //     values.ProofRelationFile,

    //     values?.PermanentProofRelationFile,
    //     values?.MailingProofRelationFile

    //   ]

    //   let fileResponse

    //   let counter = 0

    //   fileData.forEach((element, index) => {
    //     fileResponse = PostData.FileAndImageUpload(element, setError, true);
    //     fileResponse.then((value) => {
    //       console.log('save file is=========>>', value)

    //       let promise = new Promise((resolve, reject) => {


    //         if (index == 0) {
    //           ProofRelationFileName1 = value?.data?.fileName
    //           counter += 1;
    //         }
    //         else if (index == 1) {
    //           PermanentProofRelationFileparam = value?.data?.fileName
    //           counter += 1;

    //         }
    //         else if (index == 2) {
    //           MailingProofRelationFileparam = value?.data?.fileName
    //           counter += 1;
    //         }


    //         if (counter == 3) {
    //           resolve('success')
    //         }
    //       })
    //       promise.then(data => {
    //         if (data) {
    //           SaveOnContinueSubmit(paramval)
    //         }
    //       })


    //     })

    //   })


    // }
    if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

      let fileData = [
        values.ProofRelationFile,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed

      ]

      let fileResponse

      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {
          console.log('save file is=========>>', value)

          let promise = new Promise((resolve, reject) => {


            if (index == 0) {
              ProofRelationFileName1 = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;

            }


            if (counter == 4) {
              resolve('success')
            }
          })
          promise.then(data => {
            if (data) {
              SaveOnContinueSubmit(paramval)
            }
          })


        })

      })


    }
    else {
      SaveOnContinueSubmit(paramval)
    }





  }

  const handleContinueSubmit = (e) => {
    e?.preventDefault();
    setBackAndContinueBtnStatus(true)
    logEvent(analytics, 'aof_income_det_press_continue');
    if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') {
      remitanceValue = "7";
      remitanceName = 'Resident Pakistani'
    }
    else if (values?.Citizenship?.children == "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "1"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "2"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children == 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "3"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "4"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }
    else if (values?.Citizenship?.children != "Pakistan" && values?.Resident?.children != 'Resident') {
      if (values?.BasisOfRemittance?.value == 1) {
        remitanceValue = "5"
        remitanceName = "Yes, I'll do this (Repatriable)"
      }
      else {
        remitanceValue = "6"
        remitanceName = "No, I won't do this (Non-Repatriable)"
      }
    }








    if (values.ProofRelationFile || values.PermanentProofRelationFile || values?.MailingProofRelationFile) {

      let fileData = [
        values.ProofRelationFile,
        values?.PermanentProofRelationFile,
        values?.MailingProofRelationFile,
        values?.ProofRelationFileUnCompressed

      ]

      let fileResponse

      let counter = 0

      fileData.forEach((element, index) => {
        fileResponse = PostData.FileAndImageUpload(element, setError, true);
        fileResponse.then((value) => {
          console.log('save file is=========>>', value)

          let promise = new Promise((resolve, reject) => {


            if (index == 0) {
              ProofRelationFileName1 = value?.data?.fileName
              counter += 1;
            }
            else if (index == 1) {
              PermanentProofRelationFileparam = value?.data?.fileName
              counter += 1;

            }
            else if (index == 2) {
              MailingProofRelationFileparam = value?.data?.fileName
              counter += 1;
            }
            else if (index == 3) {
              ProofRelationFileUnCompressedvar = value?.data?.fileName
              counter += 1;

            }


            if (counter == 4) {
              resolve('success')
            }
          })
          promise.then(data => {
            if (data) {
              SaveOnContinueSubmit()
            }
          })


        })

      })


    }

    else {
      SaveOnContinueSubmit()
    }

  }



  const SaveOnContinueSubmit = (paramval) => {


    localStorage.setItem("save&exist", "true");
    // let obj = {
    //   provinceList: values?.residentiaProvinceList,
    //   cityList: values?.residentialCitiesList
    // }
    let params = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      status: false, // status true for submition and false for save and exist
      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      // below section for Personal  Detail
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      SALUTATION: values?.Salutations.value,
      SALUTATION_KEY: values?.Salutations?.children?.toUpperCase(),
      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,
      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,

      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,
      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,

      // Xb: obj ,
      // PERMANENT_CITY_TOWN: values?.City?.value,
      // PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,


      // OTHERCITY_TOWN_VILLAGE: values?.otherCities,
      // Residential Adddrss feilds start

      // Mailing Adddrss feilds start
      Xd: values?.MailingAddress == false ? "true" : "false",
      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,



      COUNTRY: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
          values?.mailCountry?.iso3 : values?.mailCountry?.iso2
        : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




      // COUNTRY_KEY: values?.country?.label || values?.country?.children,
      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,




      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",









      email: values?.email ? values?.email : signedEmail,
      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),
      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),

      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      // PROOF_OF_ADDRESS_MAILING: values.MailingProofRelationFileName ? values.MailingProofRelationFileName : '',
      // PROOF_OF_ADDRESS_MAILING_TYPE: values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : '',

      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',



      // number: "03" + values?.Number.slice(-9),
      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',
      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',

      RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName1 ? ProofRelationFileName1 : '',
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // NAME_NMN: values?.NomineeName,
      // IDENTIFICATION_NMN: values?.NomineeIDType,
      // RELATIONSHIP_NMN: values?.NomineeRelation?.value,
      // RELATIONSHIP_NMN_KEY: values?.NomineeRelation?.children,
      // CNIC_NMN: values?.NomineeIDNumber,
      // CNIC_ISSUE_DATE_NMN: values?.NomineeIssueDate,
      // CNIC_EXPIRY_DATE_NMN: values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate,
      // CNIC_LIFETIME_NMN: values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false",
      // *********************   below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
      OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
      ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
      ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
      E_WALLET_PROVIDER: values?.ewalletprovider?.value ? values?.ewalletprovider?.value : "",
      E_WALLET_PROVIDER_KEY: values?.ewalletprovider?.children ? values?.ewalletprovider?.children : "",
      OTHER_E_WALLET_PROVIDER: values?.otherewalletprovider,
      E_WALLET_NUMBER: values?.ewalletnumber,


      // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      // Remittance: values?.BasisOfRemittance?.value?  values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ?  values?.BasisOfRemittance?.children :"",

      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************
      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : '',
      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : '',
      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : "",


      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?





      // Not found for following


      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"
    };


    axios
      .post("account-details/", params)
      .then((value) => {
        // setsendingReq(false);
        setBackAndContinueBtnStatus(false)
        if (paramval !== 'back') {
          // handleDrctChange('step', 2)
          nextStep()
        }
        // else {
        //   nextStep()
        // }





      })
      .catch(function (error) {
        // setsendingReq(false);
        setBackAndContinueBtnStatus(false)
        setErrorMessage(true)
        console.log(error.response);
      });

  }

  const submitForm = () => {
    logEvent(analytics, 'aof_income_det_press_save_and_exit');
    localStorage.setItem("save&exist", "true");

    // let obj = {
    //   provinceList: values?.residentiaProvinceList,
    //   cityList: values?.residentialCitiesList
    // }
    let params = {
      uid: JSON.parse(localStorage.getItem("user"))?.user_id,
      status: false, // status true for submition and false for save and exist
      RelationUS: values?.USResident,
      NonRelationUSPAK: values?.TaxPayer,
      RelationOrganization: values?.AssoiciatedEmployee,
      EarnIncome: values?.EarnIncome,
      // below section for Personal  Detail
      ACCOUNT_TYPE: values?.Type?.value,
      ACCOUNT_TYPE_KEY: values?.Type?.children,
      //ACCOUNT_TYPE: 'NKA',
      //ACCOUNT_TYPE_KEY: 'Normal Account',
      SALUTATION: values?.Salutations.value,
      SALUTATION_KEY: values?.Salutations?.children?.toUpperCase(),
      firstName: values?.firstName,
      lastName: values?.lastName,
      PLACE_OF_BIRTH: values?.placeOfBirth,
      GENDER: values?.Gender,
      MARITAL_STATUS: values?.MaritalStatus,
      RELATIONSHIP1: values?.Relation?.value,
      RELATIONSHIP1_KEY: values?.Relation?.children,
      FATHER_HUSBAND_NAME: values?.RelativeName,
      DATE_OF_BIRTH: values?.BirthDay,
      NATIONALITY: values?.Citizenship?.value,
      NATIONALITY_KEY: values?.Citizenship?.children,
      residentialStatus: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "02" : "01",
      RESIDENT_KEY: values?.IDType == 'NICOP' || values?.IDType == 'POC' ? "Non-Resident" : "Resident",
      // Residential Adddrss feilds start
      PERMANENT_ADDRESS_1: values?.Apt,
      PERMANENT_ADDRESS_2: values?.street,
      // PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.iso3,
      // MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,
      PERMANENT_ADDRESS_3: values?.PermannentAddressLine3 ? values?.PermannentAddressLine3 : values?.country?.label,
      MAILING_ADDRESS_3: values?.MailingAddressLine3 ? values?.MailingAddressLine3 : values?.country?.label ? values?.country?.label : values?.country?.iso3 || values?.country?.iso2,

      // Xb: obj ,
      // PERMANENT_CITY_TOWN: values?.City?.value,
      // PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,


      // OTHERCITY_TOWN_VILLAGE: values?.otherCities,
      // Residential Adddrss feilds start

      // Mailing Adddrss feilds start
      Xd: values?.MailingAddress == false ? "true" : "false",
      MAILING_ADDRESS_2: values?.MailingAddress == false ? values?.Mailstreet : values?.street,
      MAILING_ADDRESS_1: values?.MailingAddress == false ? values?.MailApt : values?.Apt,
      // MAILING_ADDRESS_3: values?.MailingAddress == false ? (values?.mailCountry?.iso3 || values?.mailCountry?.label) : values?.country?.iso3,




      COUNTRY: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ?
          values?.mailCountry?.iso3 : values?.mailCountry?.iso2
        : (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2,




      // COUNTRY_KEY: values?.country?.label || values?.country?.children,
      COUNTRY_KEY: values?.mailCountry?.label || values?.mailCountry?.label ? values?.mailCountry?.label : values?.mailCountry?.iso3,




      CITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        (values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan') ? values?.MailCity?.City_Code || values?.MailCity?.label : '' :

        (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      CITY_TOWN_VILLAGE_KEY: values?.MailingAddress == false ? values?.MailCity?.label : values?.City?.label,


      PROVINCE_STATE: values?.MailingAddress == false ?

        ((values?.mailCountry?.children == 'Pakistan' || values?.mailCountry?.label == 'Pakistan')
          ? values?.MailProvinces?.Province_code || values?.MailProvinces?.state_code : '')


        : (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',

      PROVINCE_STATE_KEY: values?.MailingAddress == false ? values?.MailProvinces?.label : values?.Provinces?.label,
      OTHERPROVINCE_STATE: values?.MailingAddress == false ? (values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailProvinces?.label : "" : (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.Provinces?.Province_code || values?.Provinces?.state_code : '',
      OTHERCITY_TOWN_VILLAGE: values?.MailingAddress == false ?
        ((values?.mailCountry?.label != 'Pakistan' && values?.mailCountry?.children != 'Pakistan') ? values?.MailCity?.label : "") :

        (values?.country?.label != 'Pakistan' && values?.country?.children != 'Pakistan') ? values?.City?.City_Code || values?.City?.label : '',





      // permanent country list

      PERMANENT_COUNTRY: (values?.country?.children == 'Pakistan' || values?.country?.label == 'Pakistan') ? values?.country?.iso3 : values?.country?.iso2 || values?.country?.iso3,
      COUNTRY1_KEY: values?.country?.label || values?.country?.children,
      PERMANENT_PROVINCE: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PROVINCE_KEY: values?.Provinces?.label,
      PERMANENT_CITY_TOWN: (values?.country?.children !== 'Pakistan' && values?.country?.label !== 'Pakistan') ? '' : values?.City?.City_Code || values?.City?.label,
      PERMANENT_CITY_TOWN_VILLAGE_KEY: values?.City?.label,

      PERMANENT_OTHERPROVINCE: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.Provinces?.Province_code || values?.Provinces?.state_code,
      PERMANENT_OTHERCITY_TOWN: (values?.country?.label == 'Pakistan' || values?.country?.children == 'Pakistan') ? "" : values?.City?.City_Code ? values?.City?.City_Code : values?.City?.label,
      EMPLOYER_ADDRESS: values?.EmployStreet ? values?.EmployStreet : "",









      email: values?.email ? values?.email : signedEmail,
      // PERMANENT_CELL_NO: "03" + values?.Number.slice(-9),
      PERMANENT_CELL_NO: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),
      PERMANENT_EMAIL: values?.email ? values?.email : signedEmail,
      relationWithMobileNo: values?.CellPhone,
      number: (values?.Number?.substring(0, 2) == 92) ? "0" + values?.Number?.substring(2, 12) : values?.Number.slice(-12),

      PROOF_OF_ADDRESS: values?.PermanentProofOfAddressCheckbox == false ? (values.PermanentProofRelationFileName ? values.PermanentProofRelationFileName : PermanentProofRelationFileparam ? PermanentProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_TYPE: values?.PermanentProofOfAddressCheckbox == false ? (values?.permanentProofOfAddressType?.children ? values?.permanentProofOfAddressType?.children : "") : '',

      // PROOF_OF_ADDRESS_MAILING: values.MailingProofRelationFileName ? values.MailingProofRelationFileName : '',
      // PROOF_OF_ADDRESS_MAILING_TYPE: values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : '',

      PROOF_OF_ADDRESS_MAILING: values?.MailingProofOfAddressCheckbox == false ? (values.MailingProofRelationFileName ? values.MailingProofRelationFileName : MailingProofRelationFileparam ? MailingProofRelationFileparam : '') : '',
      PROOF_OF_ADDRESS_MAILING_TYPE: values?.MailingProofOfAddressCheckbox == false ? (values?.mailingProofOfAddressType?.children ? values?.mailingProofOfAddressType?.children : "") : '',



      // number: "03" + values?.Number.slice(-9),
      RELATIONSHIP: values?.CellPhone == 2 ? values?.proofRelation.value : '1',
      RELATIONSHIP_KEY: values?.CellPhone == 2 ? values?.proofRelation.children : 'Self',
      RELATIVE_NAME: values?.CellPhone == 2 ? values?.ProofRelationName : '',
      relativeCNIC: values?.CellPhone == 2 ? ((values?.proofRelation.children == 'Self' || values?.proofRelation.children == 'Company') ? '' : values?.RelativeCNIC) : '',
      RELATIVE_PROOF: values.ProofRelationFileName ? values.ProofRelationFileName : ProofRelationFileName1 ? ProofRelationFileName1 : '',
      RELATIVE_PROOF_UC: ProofRelationFileUnCompressedvar ? ProofRelationFileUnCompressedvar : values?.ProofRelationFileNameUC ? values?.ProofRelationFileNameUC : '',
      NAME_NMN: values?.addnominee == true ? (values?.NomineeName ? values?.NomineeName : '') : '',
      IDENTIFICATION_NMN: values?.addnominee == true ? (values?.NomineeIDType ? values?.NomineeIDType : '') : '',
      RELATIONSHIP_NMN: values?.addnominee == true ? (values?.NomineeRelation?.value ? values?.NomineeRelation?.value : '') : '',
      RELATIONSHIP_NMN_KEY: values?.addnominee == true ? (values?.NomineeRelation?.children ? values?.NomineeRelation?.children : '') : '',
      CNIC_NMN: values?.addnominee == true ? (values?.NomineeIDNumber ? values?.NomineeIDNumber : '') : '',
      CNIC_ISSUE_DATE_NMN: values?.addnominee == true ? (values?.NomineeIssueDate ? values?.NomineeIssueDate : '') : '',
      CNIC_EXPIRY_DATE_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate) : '',
      CNIC_LIFETIME_NMN: values?.addnominee == true ? (values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false") : '',

      // NAME_NMN: values?.NomineeName,
      // IDENTIFICATION_NMN: values?.NomineeIDType,
      // RELATIONSHIP_NMN: values?.NomineeRelation?.value,
      // RELATIONSHIP_NMN_KEY: values?.NomineeRelation?.children,
      // CNIC_NMN: values?.NomineeIDNumber,
      // CNIC_ISSUE_DATE_NMN: values?.NomineeIssueDate,
      // CNIC_EXPIRY_DATE_NMN: values?.NomineeLifeTimeExpiry == true ? '' : values?.NomineeExpiryDate,
      // CNIC_LIFETIME_NMN: values?.NomineeLifeTimeExpiry ? JSON.stringify(values?.NomineeLifeTimeExpiry) : "false",
      // *********************   below section for Income Detail  ***************************************
      idType: values?.IDType,
      CNIC: values?.CNIC,
      issueDate: values?.IssueDate,
      DATE_OF_EXPIRY: values?.lifeTimeExpiry == true ? '' : values?.ExpiryDate,
      LIFETIME_KEY: values?.lifeTimeExpiry ? JSON.stringify(values?.lifeTimeExpiry) : "false",
      IBAN: values.IBAN,
      BANK_NAME: values?.BankName,
      // employmentStatus: values.EmploymentStatus,
      EMPLOYER_NAME: values?.CompName,
      OCCUPATION: values?.BussType?.value ? values?.BussType?.value : "",
      OCCUPATION_KEY: values?.BussType?.children ? values?.BussType?.children : "",
      JOB_TITLE: values?.JobTitle,
      Department: values?.Department,
      OTHER_OCCUPATION: values?.BussType?.children == "Other" ? values?.OtherOccupation : '',
      // for Now Employee Apartment is removed from income detail section
      // employeeApt:values?.EmployApt,

      GROSS_ANNUAL_INCOME: values?.AnnualIncome?.value ? values?.AnnualIncome?.value : "",
      GROSS_ANNUAL_INCOME_KEY: values?.AnnualIncome?.children ? values?.AnnualIncome?.children : "",
      ZAKAT_STATUS: values?.Zakat?.value ? values?.Zakat?.value : "",
      ZAKAT_STATUS_KEY: values?.Zakat?.children ? values?.Zakat?.children : "",
      E_WALLET_PROVIDER: values?.ewalletprovider?.value ? values?.ewalletprovider?.value : "",
      E_WALLET_PROVIDER_KEY: values?.ewalletprovider?.children ? values?.ewalletprovider?.children : "",
      OTHER_E_WALLET_PROVIDER: values?.otherewalletprovider,
      E_WALLET_NUMBER: values?.ewalletnumber,


      // Remittance: values?.BasisOfRemittance?.value ? values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ? values?.BasisOfRemittance?.children : "",
      Remittance: remitanceValue,
      RemittanceKey: remitanceName,
      // Remittance: values?.BasisOfRemittance?.value?  values?.BasisOfRemittance?.value : "",
      // RemittanceKey: values?.BasisOfRemittance?.children ?  values?.BasisOfRemittance?.children :"",

      SOURCE_OF_INCOME: values?.sourceofincome, // this feild still need to be manage on screen not in figma
      UKN: values?.UKN,
      MOTHER_MAIDEN_NAME: values?.MOTHER_MAIDEN_NAME,
      // ************************* below Section for Documentations *****************************************
      CNIC_FRONT: values?.CNICFileFrontName ? values?.CNICFileFrontName : '',
      CNIC_BACK: values?.CNICFileBackName ? values?.CNICFileBackName : '',
      ADD_PROOF: values?.sendSalerySlipName ? values?.sendSalerySlipName : "",


      //  below Section for Terms and conditions
      TERMS_CONDITIONS: "Y", //what to send in this?





      // Not found for following


      proofofRelationship: "",
      Client_Code: "",
      TELEPHONE_OFFICE: "",
      TELEPHONE_RESIDENCE: "",
      FAX: "",
      // PERMANENT_COUNTRY: values?.mailCountry?.value,

      PERMANENT_TELEPHONE_OFFICE: "",
      PERMANENT_TELEPHONE_RESIDENCE: "",
      PERMANENT_FAX: "",
      // OTHER_OCCUPATION: "",
      EMP_ADD_PROOF: "",
      SIGNATURE_PROOF: "",
      // TERMS_CONDITIONS: "",
      ProofofIBAN: "",
      // ZAKAAT_DECLARATION: "",
      // Remittance: "",

      // These are to be send empty for Now
      Salutation_ATR: "",
      CLIENT_NAME_ATR: "",
      IDENTIFICATION_ATR: "",
      CNIC_ATR: "",
      CNIC_EXPIRY_DATE_ATR: "",
      CNIC_LIFETIME_ATR: "",
      Mobile_ATR: "",
      Email_ATR: "",
      Mailing_ADDRESS_ATR_1: "",
      Mailing_ADDRESS_ATR_2: "",
      Mailing_ADDRESS_ATR_3: "",
      Mailing_Country_ATR: "",
      Mailing_Province_ATR: "",
      Other_Mailing_Prov_ATR: "",
      Mailing_CITY_ATR: "",
      Other_Mailing_CITY_ATR: "",
      Landline_ATR: "",
      FAX_ATR: "",
      COMP_STATUS: "false"
    };


    console.log('params are -=--------------??', params)

    axios
      .post("account-details/", params)
      .then((value) => {
        setsendingSaveReq(false);
        if (value.data) {
          openSaveExitModel();
        }
      })
      .catch(function (error) {
        setsendingSaveReq(false);
        console.log(error.response);
      });

  }




  return (
    <div className="container-fluid  px-0 bg-grey-100 py-5">
      <PersonalInfo handleDrctChange={handleDrctChange} values={values} />
      <div className="container px-0">
        <div className="mt-80">
          <div className="px-3">
            <div className="d-inline-flex w-100">
              <p className="fs32 ls4 fw-800 t-grey-800">Income Details</p>
            </div>
            <form onSubmit={handleContinueSubmit} className="form" id='AOF-form'>
              <div className="row justify-content-between">
                <div className="col-12 mb-3 col-sm-4 d-flex flex-column mb-3">
                  <label
                    htmlFor="IDType"
                    className="col-12 col-form-label fw-500"
                  >
                    Choose Identity Document
                  </label>

                  <>
                    {/* <Select
                       options={IDType}
                       id="IDType"
                      onChange={(e) => handleDrctChange("IDType", e.value)}            
                      placeholder="ID Type"
                      defaultInputValue={values.IDType}
                   
                    /> */}

                    <div className="mt-auto">
                      <Select defaultValue={values?.IDType ? values?.IDType : undefined} placeholder="ID Type" onSelect={(value, event) => handleDrctChange("IDType", event.value)} rules={[{ required: true }]} disabled={values?.editFormStatus == "true"}>

                        {/* {IDType.map(idType => (
                          <Option key={idType?.value}>{idType?.label}</Option>
                        ))} */}

                        {(values.Resident.children === 'Resident' ? IDType : IDTypeNonResident).map(idType => (
                          <Option key={idType?.value}>{idType?.label}</Option>
                        ))}

                      </Select>
                    </div>
                    {values.IDType == "" && <RequiredFeild />}
                    {!values.IDType && values.continues ? <span id="IDType" className="text-danger fs10" >Please Select IDType</span> : ""}

                  </>
                  {(values.Resident?.children == 'Resident') && (values?.IDType == 'POC' || values?.IDType == 'NICOP') &&
                    <p className="fw-400 fs12 t-grey-400 mt8"> Your OTP will be sent to the registered email within 2 working days</p>

                  }

                  {(values.Resident?.children == 'Non-Resident') && (values?.IDType == 'POC' || values?.IDType == 'NICOP') &&
                    <p className="fw-400 fs12 t-grey-400 mt8">Your OTP will be sent to the registered email within 2 working days</p>

                  }

                  {(values.Resident?.children == 'Resident') && (values?.IDType == 'CNIC' || values?.IDType == 'SNIC') &&
                    <p className="fw-400 fs12 t-grey-400 mt8">Your OTP will be sent to the registered phone number within 2 working days</p>

                  }

                  {(values.Resident?.children == 'Non-Resident') && (values?.IDType == 'CNIC' || values?.IDType == 'SNIC') &&
                    <p className="fw-400 fs12 t-grey-400 mt8">Your OTP will be sent to the registered phone number within 2 working days</p>

                  }


                </div>

                <div className="col-12 mb-2 col-sm-8 d-flex flex-column mb-3">
                  <label
                    htmlFor="CNIC"
                    className="col-12 col-form-label fw-500"
                  >
                    {/* CNIC */}
                    {values?.IDType ? values.IDType : 'CNIC'} Number
                  </label>

                  <input
                    type="text"
                    name="CNIC"
                    className="form-control"
                    placeholder="44444-2223334-7"
                    value={values.CNIC}
                    onChange={handleChange}
                    id="CNIC"
                    minLength="13"
                    maxLength="13"
                    required
                    disabled={values?.editFormStatus == "true"}

                  />
                  {(values.CNIC == "" || values.CNIC?.length < 13) && <RequiredFeild />}
                  {!values.CNIC && values.continues ? <span id="IDType" className="text-danger fs10" >Please fill CNIC</span> : ""}
                </div>

                <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                  <label
                    htmlFor="issueDay"
                    className="col-12 col-form-label fw-500"
                  >
                    Issue Date (e.g. 28-02-1995)
                    <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only numbers and dashes are accepted." placement="bottom"
                    >
                      <span className="ml10">
                        <HelpIcon />
                      </span>
                    </Tooltip>
                  </label>

                  <div className="mt-auto">
                    <DatePickerInput
                      onChange={(e) =>
                        onChangeDate(
                          e,
                          "IssueDate",
                          new Date("05/11/2019"),
                          new Date()
                        )
                      }
                      className="my-custom-datepicker-component"
                      defaultValue={
                        values?.IssueDate?.includes("N") ? "" : values?.IssueDate
                      }
                      name="DatePicker"
                      placeholder="dd-mm-yyyy"
                      maxDate={new Date()}
                      startDate={new Date()}
                      // readOnly
                      maxLength="10"
                      showOnInputClick={true}
                      displayFormat="DD-MM-YYYY"
                      required
                      disabled={values?.editFormStatus == "true"}
                    /></div>
                  {values?.IssueDate == "" && <RequiredFeild />}
                  {!values.IssueDate && values.continues ? <span className="text-danger fs10" >Please select Issue Date</span> : ""}
                </div>

                {!values?.lifeTimeExpiry && (
                  <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">

                    {/* {values?.IssueDate && <> */}


                    <label
                      htmlFor="expiryDay"
                      className="col-12 col-form-label fw-500"
                    >
                      Expiry Date (e.g. 28-02-1995)
                      <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Only numbers and dashes are accepted." placement="bottom"
                      >
                        <span className="ml10">
                          <HelpIcon />
                        </span>
                      </Tooltip>
                    </label>
                    <div className="mt-auto">
                      <DatePickerInput
                        onChange={(e) =>
                          onChangeDate(
                            e,
                            "ExpiryDate",
                            new Date("05-11-2019"),
                            new Date()
                          )
                        }
                        className="my-custom-datepicker-component"
                        defaultValue={
                          values?.ExpiryDate?.includes("N") ? "" : values?.ExpiryDate
                        }
                        name="DatePicker"
                        placeholder="dd-mm-yyyy"
                        minDate={(values?.IssueDate?.includes("N") || values?.IssueDate == "") ? new Date() : new Date(values?.IssueDate)}
                        startDate={(values?.IssueDate?.includes("N") || values?.IssueDate == "") ? new Date() : new Date(values?.IssueDate)}
                        // readOnly
                        maxLength="10"
                        showOnInputClick={true}
                        displayFormat="DD-MM-YYYY"
                        required
                      />
                      {values.ExpiryDate === "" && !values.lifeTimeExpiry && <RequiredFeild />}
                      {!values.ExpiryDate && !values.lifeTimeExpiry && values.continues ? <span className="text-danger fs10" >Please select Expiry Date</span> : ""}

                    </div>


                  </div>
                )}




                {/* {values?.IssueDate && <> */}

                <div className="col-12 col-sm-6 my-auto col-lg-4 d-flex flex-column">
                  <label
                    htmlFor="lifeTimeExpiry"
                    className="col-12 pb-2 pt-0 col-form-label fw-500"
                  >
                    Expiry Limit
                  </label>
                  <div className="mt-auto">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      defaultChecked={values.lifeTimeExpiry}
                      onChange={handleChange}
                      name="lifeTimeExpiry"
                      id="lifeTimeExpiry"
                    />
                    <label
                      className="form-check-label lifetimeexpirylabel"
                      htmlFor="lifeTimeExpiry"
                    >
                      Life Time Expiry
                    </label>
                  </div>
                </div>

                {/* </>} */}

                <div
                  className={`col-12 mt-2 col-sm-8 d-flex flex-column ${values?.IBANError && values?.IBAN.length > 0 ? "brdr-error"
                    : "qw"
                    }`}
                >
                  <label
                    htmlFor="IBAN"
                    className="col-12 col-form-label fw-500"
                  >
                    IBAN Number
                    <Tooltip overlayStyle={{ maxWidth: '440px' }} title={
                      <>
                        <p className="fw-500 fs14 text-white mb-0">
                          An IBAN is a unique number of your bank account. You can find it on your online banking portal,
                          bank mobile app or in your cheque book. Alternatively, you can approach your bank's customer
                          support. <br /> <br />

                          Mobile wallet IBANs won't be accepted (easypaisa, JazzCash, etc).
                        </p>
                      </>
                    } placement="bottom"
                    >
                      <span className="ml10">
                        <HelpIcon />
                      </span>
                    </Tooltip>
                  </label>


                  <input
                    type="text"
                    name="IBAN"
                    className="IBAN form-control"
                    placeholder="PK01 MEZN 0000 1111 2222 3333"
                    value={values.IBAN}
                    onChange={onHandleChange}
                    id="IBAN"
                    minLength="29"
                    maxLength="29"
                    required
                    disabled={values?.editFormStatus == "true"}

                  />
                  {(values.IBAN === "" || values.IBAN.length < 29) && <RequiredFeild />}
                  {!values.IBAN && values.continues ? <span className="text-danger fs10" >Please fill Iban</span> : ""}


                  <p className="fw-400 fs14 t-grey-400 mt8">
                    Please carefully input your 24 characters IBAN Number.
                  </p>
                </div>

                <div className="col-12  mt-2   col-sm-6 col-lg-4 d-flex flex-column">
                  {values?.showOtherBankFeild &&
                    <>

                      <label
                        htmlFor="BankName"
                        className="col-12 col-form-label fw-500"
                      >
                        Bank Name
                      </label>

                      <input
                        type="text"
                        name="BankName"
                        className="form-control"
                        placeholder="Bank Name"
                        value={values?.BankName}
                        onChange={handleChange}
                        id="BankName"
                        maxLength="40"
                        required

                      />

                    </>
                  }





                  {values?.showBankFeild &&
                    <>

                      <label
                        htmlFor="BankName"
                        className="col-12 col-form-label fw-500"
                      >
                        Bank Name
                      </label>

                      <input
                        type="text"
                        name="BankName"
                        className="form-control"
                        placeholder="Bank Name"
                        value={values?.BankName}

                        id="BankName"
                        disabled
                      />
                      
                    </>
                  }

                </div>

                <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                  <label htmlFor="ewalletprovider" className="col-12 col-form-label fw-500">
                    E-Wallet Provider
                  </label>

                  <div className="mt-auto">
                    <Select defaultValue={values.ewalletprovider ? values.ewalletprovider : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("ewalletprovider", e)} rules={[{ required: false }]}>
                      {EWalletProvider.map(wallet => (
                        <Option key={wallet.value}>{wallet.label}</Option>
                      ))}
                    </Select>
                  </div>
                </div>

                <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                  <label htmlFor="otherewalletprovider" className="col-12 col-form-label fw-500">
                    Other E-Wallet Provider
                  </label>

                  <input
                    type="text"
                    name="otherewalletprovider"
                    className="form-control mt-auto"
                    placeholder="Umda Pay"
                    value={values.otherewalletprovider}
                    onChange={handleChange}
                    id="otherewalletprovider"
                    maxLength="50"
                  />
                </div>

                <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                  <label htmlFor="ewalletnumber" className="col-12 col-form-label fw-500">
                    E-Wallet Number
                  </label>

                  <input
                    type="text"
                    name="ewalletnumber"
                    className="form-control mt-auto"
                    placeholder="03210000000"
                    value={values.ewalletnumber}
                    onChange={handleChange}
                    id="ewalletnumber"
                    maxLength="50"
                  />
                </div>


                <div className="w-100">
                  <hr className="t-grey-200 mt-40"></hr>
                </div>
                <>
                  <div className="col-12">
                    <div className="row mt-40">


                      {/* <div className="col-12 col-sm-6 col-lg-4 ">
                      <label
                        htmlFor="Employed"
                        className="col-12 col-form-label fw-500"
                      >
                        Employement Status
                      </label>
                      <ul className="text-center combineButton RadioToButton px-0 d-flex justify-content-center">
                        <li className="w-50">
                          <input
                            type="radio"
                            id="Employed"
                            name="EmploymentStatus"
                            value="Employed"
                            defaultChecked={values.EmploymentStatus == 1 ? "Employed" : "Self Employed"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="Employed" className="btn-txt mb-0 ">
                            Employed
                          </label>
                        </li>
                        <li className="w-50">
                          <input
                            type="radio"
                            id="SelfEmployed"
                            name="EmploymentStatus"
                            value="SelfEmployed"
                            defaultChecked={values.EmploymentStatus == "SelfEmployed"}
                            onChange={handleChange}
                            required={true}
                          />
                          <label htmlFor="SelfEmployed" className="btn-txt mb-0 ">
                            Self Employed
                          </label>
                        </li>
                      </ul>
                    </div> */}


                      <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                        <label
                          htmlFor="CompName"
                          className="col-12 col-form-label fw-500"
                        >
                          Business / Employer Name
                          <Tooltip overlayStyle={{ maxWidth: '288px' }} title="Leave this field empty if it doesn't apply to you." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>
                        <input
                          type="text"
                          name="CompName"
                          className="form-control mt-auto"
                          placeholder="Google Inc"
                          value={values.CompName}
                          onChange={handleChange}
                          id="CompName"
                          maxLength="80"
                        // required
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                        <label
                          htmlFor="Occupations "
                          className="col-12 col-form-label fw-500"
                        >
                          Occupation
                        </label>

                        <div className="mt-auto">
                          {/* <Select
                          onChange={(e) => handleDrctChange("BussType", e)}
                          placeholder="Type of Business"
                          options={Occupations}
                          defaultInputValue={values.BussType.label}
                        /> */}

                          <Select defaultValue={values.BussType ? values.BussType : undefined} placeholder="Type of Business" onSelect={(value, event) => handleDrctChange("BussType", event)} rules={[{ required: true }]} >

                            {Occupations.map(occupations => (
                              <Option key={occupations.value}>{occupations.label}</Option>
                            ))}

                          </Select>
                        </div>
                        {!values.BussType.value && <RequiredFeild />}
                        {!values.BussType.value && values.continues ? <span className="text-danger fs10" >Please Select Occupation</span> : ""}
                      </div>

                      {values.BussType.children == 'Other' &&
                        <div className="col-12 mb-3 col-sm-6 col-lg-4 d-flex flex-column">
                          <label
                            htmlFor="EmployApt"
                            className="col-12 col-form-label fw-500"
                          >
                            Specify Other Occupation
                          </label>

                          <input
                            type="text"
                            name="OtherOccupation"
                            className="form-control mt-auto"
                            placeholder="Other Occupation"
                            value={values.OtherOccupation}
                            onChange={handleChange}
                            id="EmployApt"
                            required
                            maxLength="50"

                          />
                          {!values.OtherOccupation && <RequiredFeild />}
                          {!values.OtherOccupation && values.continues ? <span className="text-danger fs10" >Please fill Occupation</span> : ""}
                        </div>
                      }
                      <div className="col-12 mb-3 col-sm-6 col-lg-4 d-flex flex-column">
                        <label
                          htmlFor="JobTitle"
                          className="col-12 col-form-label fw-500"
                        >
                          Job Title
                          <Tooltip overlayStyle={{ maxWidth: '288px' }} title="Leave this field empty if it doesn't apply to you." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <input
                          type="text"
                          name="JobTitle"
                          className="form-control mt-auto"
                          placeholder="Developer, Designer, Manager"
                          value={values.JobTitle}
                          onChange={handleChange}
                          id="JobTitle"
                          // required
                          maxLength="50"
                        />
                      </div>
                      <div className="col-12 mb-3 col-sm-6 col-lg-4">
                        <label
                          htmlFor="EmployApt"
                          className="col-12 col-form-label fw-500"
                        >
                          Department
                          <Tooltip overlayStyle={{ maxWidth: '288px' }} title="Leave this field empty if it doesn't apply to you." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <input
                          type="text"
                          name="Department"
                          className="form-control"
                          placeholder="Business Development"
                          value={values.Department}
                          onChange={handleChange}
                          id="EmployApt"
                          // required
                          maxLength="50"
                        />
                      </div>
                      <div className="col-12 mb-3 col-lg-8">
                        <label
                          htmlFor="EmployStreet"
                          className="col-12 col-form-label fw-500"
                        >
                          Business / Employer Address
                          <Tooltip overlayStyle={{ maxWidth: '406px' }} title={
                            <>
                              <p className="fw-500 fs14 text-white">
                                Add the complete address of your business / employer. Please include the province, city and country. <br /> <br />

                                Example: House 1 Shahrah e Faisal Block 1 PECHS Sindh Karachi Pakistan <br /> <br />

                                Leave this field empty if it doesn't apply to you. <br /> <br />

                                Only the following special characters are allowed # * , . /
                              </p>
                            </>
                          } placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <input
                          type="text"
                          name="EmployStreet"
                          className="form-control"
                          placeholder="House 1 Shahrah e Faisal Block 1 PECHS Sindh Karachi Pakistan"
                          value={values.EmployStreet}
                          onChange={handleChange}
                          id="EmployStreet"
                          maxLength="120"
                        // required

                        />
                      </div>
                    </div>
                  </div>


                  <div className="col-12">
                    <div className="row">
                      {/* <div className="col- col-sm-4 mb-3">
                          <label
                            htmlFor="EmployApt"
                            className="col-12 text-nowrap col-form-label fw-500"
                          >
                            Suite / APT / House No # 
                          </label>

                          <input
                            type="text"
                            name="EmployApt"
                            className="form-control"
                            placeholder=""
                            value={values.EmployApt}
                            onChange={handleChange}
                            id="EmployApt"
                            required
                          />
                        </div> */}

                      <div className="col-12 col-sm-6 mb-3 col-lg-4 d-flex flex-column">
                        <label
                          htmlFor="AnualIncomes "
                          className="col-12 col-form-label fw-500"
                        >
                          Gross Annual Income
                          <Tooltip overlayStyle={{ maxWidth: '280px' }} title="Please add your pre-tax annual income." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <div className="mt-auto">

                          <Select defaultValue={values.AnnualIncome.children ? values.AnnualIncome.children : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("AnnualIncome", e)} rules={[{ required: true }]} >

                            {(values.Type.value === 'SKA' ? AnualIncomes : AnualIncomesNormal).map(anualIncomes => (
                              <Option key={anualIncomes.value}>{anualIncomes.label}</Option>
                            ))}

                          </Select>
                        </div>
                        {!values.AnnualIncome.value && <RequiredFeild />}
                        {!values.AnnualIncome.value && values.continues ? <span className="text-danger fs10" >Please Select Annual Income</span> : ""}
                      </div>
                      <div className="col-12 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                        <label
                          htmlFor="Zakat "
                          className="col-12 col-form-label fw-500"
                        >
                          Deduct Zakat?
                          <Tooltip overlayStyle={{ maxWidth: '405px' }} title="Zakat deductions may apply on dividend payouts." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <div className="mt-auto">
                          {/* <Select
                            onChange={(e) => handleDrctChange("Zakat", e)}
                            placeholder="Select any one"
                            options={Zakat}
                            defaultInputValue={values.Zakat.label}
                          /> */}
                          <Select defaultValue={values.Zakat ? values.Zakat : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("Zakat", e)} rules={[{ required: true }]}>

                            {Zakat.map(zakat => (
                              <Option key={zakat.value}>{zakat.label}</Option>
                            ))}

                          </Select>

                        </div>
                        {!values.Zakat.value && <RequiredFeild />}
                        {!values.Zakat.value && values.continues ? <span className="text-danger fs10" >Please Select Zakat</span> : ""}
                      </div>



                      {(values?.Citizenship?.children == "Pakistan" && values?.Resident?.children == 'Resident') ? (
                        <>



                        </>
                      ) : (
                        <>
                          <div className="col-12 col-sm-6 col-lg-4 mb-3 d-flex flex-column">
                            <label
                              htmlFor="BasisOfRemittance "
                              className="col-12 col-form-label fw-500"
                            >
                              Withdrawing Funds out of Pakistan
                              <Tooltip title="You’re seeing this because you’re either a non-resident Pakistani or a foreign citizen. Do you plan
                               on withdrawing your funds from Pakistan to another country? If yes, you’ll need an SCRA account." placement="bottom"
                              >
                                <span className="ml10">
                                  <HelpIcon />
                                </span>
                              </Tooltip>
                            </label>

                            <div className="mt-auto">


                              <Select defaultValue={values.BasisOfRemittance ? values.BasisOfRemittance : undefined} placeholder="Select any one" onSelect={(value, e) => handleDrctChange("BasisOfRemittance", e)} rules={[{ required: true }]}>

                                {BasisOfRemittance.map(basisOfRemittance => (
                                  <Option key={basisOfRemittance.value}>{basisOfRemittance.label}</Option>
                                ))}

                              </Select>
                            </div>
                            {(values?.BasisOfRemittance == "" || values?.BasisOfRemittance?.value == "") && <RequiredFeild />}
                          </div>



                        </>

                      )
                      }



                      <div className="col-12 mb-3 col-sm-6 col-lg-4 d-flex flex-column mb-3">
                        <label
                          htmlFor="sourceofincome"
                          className="col-12 col-form-label fw-500"
                        >
                          Source of Income
                          <Tooltip overlayStyle={{ maxWidth: '256px' }} title="Possible things you can mention: salary, business, savings, rent, commission, pension, agriculture, dividends or freelancing. If you don’t earn an income you may mention that you depend on someone else." placement="bottom"
                          >
                            <span className="ml10">
                              <HelpIcon />
                            </span>
                          </Tooltip>
                        </label>

                        <input
                          type="text"
                          name="sourceofincome"
                          className="form-control mt-auto"
                          placeholder="Salary"
                          value={values.sourceofincome}
                          onChange={handleChange}
                          id="sourceofincome"
                          required
                          maxLength="50"

                        />
                        {!values.sourceofincome && <RequiredFeild />}
                        {!values.sourceofincome && values.continues ? <span className="text-danger fs10" >Please Provide Source</span> : ""}
                      </div>
                    </div>
                  </div>

                </>


                {/* {values.EmploymentStatus == "Employed" && (
                  <>
                    <div className="col-12 mb-3 col-sm-6 col-lg-4">
                      <label
                        htmlFor="CompName"
                        className="col-12 col-form-label fw-500"
                      >
                        Employer of
                      </label>
                      <input
                        type="text"
                        name="CompName"
                        className="form-control"
                        placeholder="Company Name"
                        value={values.CompName}
                        onChange={handleChange}
                        id="CompName"
                        required
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 mb-3">
                      <label
                        htmlFor="Occupations "
                        className="col-12 col-form-label fw-500"
                      >
                        Occupation
                      </label>

                      <>
                        <Select
                          onChange={(e) => handleDrctChange("BussType", e)}
                          placeholder="Type of Business"
                          options={Occupations}
                          defaultInputValue={values.BussType.label}
                        />
                        {values.BussType == "" && <RequiredFeild />}
                      </>
                    </div>
                    <div className="col-12 col-sm-6 col-lg-4 mb-3">
                      <label
                        htmlFor="JobTitle"
                        className="col-12 col-form-label fw-500"
                      >
                        Job Designation
                      </label>

                      <input
                        type="text"
                        name="JobTitle"
                        className="form-control"
                        placeholder="Job Title"
                        value={values.JobTitle}
                        onChange={handleChange}
                        id="JobTitle"
                        required
                      />
                    </div>
                    <div className="col-12 mb-3 col-sm-4">
                      <label
                        htmlFor="EmployApt"
                        className="col-12 col-form-label fw-500"
                      >
                        Department
                      </label>

                      <input
                        type="text"
                        name="Department"
                        className="form-control"
                        placeholder=""
                        value={values.Department}
                        onChange={handleChange}
                        id="EmployApt"
                        required
                      />
                    </div>
                    <div className="col-12">
                      <div className="row">
                        <div className="col-12 col-sm-4 mb-3">
                          <label
                            htmlFor="EmployApt"
                            className="col-12 text-nowrap col-form-label fw-500"
                          >
                            Suite / APT / House No # 
                          </label>

                          <input
                            type="text"
                            name="EmployApt"
                            className="form-control"
                            placeholder=""
                            value={values.EmployApt}
                            onChange={handleChange}
                            id="EmployApt"
                            required
                          />
                        </div>
                        <div className="col-12 mb-3 col-sm-8">
                          <label
                            htmlFor="EmployStreet"
                            className="col-12 col-form-label fw-500"
                          >
                            Employer Address
                          </label>

                          <input
                            type="text"
                            name="EmployStreet"
                            className="form-control"
                            placeholder="Street Address"
                            value={values.EmployStreet}
                            onChange={handleChange}
                            id="EmployStreet"
                            required
                          />
                        </div>
                        <div className="col-12 col-sm-6 mb-3 col-lg-4">
                          <label
                            htmlFor="AnualIncomes "
                            className="col-12 col-form-label fw-500"
                          >
                            Annual Income
                          </label>

                          <>
                            <Select
                              onChange={(e) =>
                                handleDrctChange("AnnualIncome", e)
                              }
                              placeholder="Select any one"
                              options={values.Type.value==='SKA'?AnualIncomes:AnualIncomesNormal}
                              defaultInputValue={values.AnnualIncome.label}
                            />
                            {values.AnnualIncome == "" && <RequiredFeild />}
                          </>
                        </div>
                        <div className="col-12 col-sm-6 col-lg-4">
                          <label
                            htmlFor="Zakat "
                            className="col-12 col-form-label fw-500"
                          >
                            Zakat
                          </label>

                          <>
                            <Select
                              onChange={(e) => handleDrctChange("Zakat", e)}
                              placeholder="Select any one"
                              options={Zakat}
                              defaultInputValue={values.Zakat.label}
                            />
                            {values.Zakat == "" && <RequiredFeild />}
                          </>
                        </div>
                      </div>
                    </div>
                  </>
                )} */}
              </div>
              <hr className="t-grey-200"></hr>



              <div className="row">
                <div className="col-12 mb-3 col-sm-6 mt16 ">
                  <label
                    className="form-check-label fw-500 fs-14 mailing-checkbox-label "
                  >
                    If you opened a brokerage account after June 2019, you'll be issued a UKN (a unique number). If you're unable to find it or don't have it, you may leave the field blank.
                  </label>
                  <div className="row">
                    <div className="col-lg-8">


                      <label
                        htmlFor="UKN"
                        className="col-12 col-form-label fw-500"
                      >
                        UKN
                        <Tooltip overlayStyle={{ maxWidth: '658px' }} title={
                          <>
                            <p className="fw-500 fs14 text-white">
                              How to get your UKN: <br /> <br />
                              Check your emails from NCCPL. They mention your UKN in email coordination. <br />
                              Call 021 111 111 622 (NCCPL helpline) and request them to provide your UKN.<br />
                              Ask the trader of your previous broker.<br /><br />
                              Example UKN: AAA1111IV
                            </p>
                          </>
                        }



                          placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>

                      <input
                        type="text"
                        name="UKN"
                        className="form-control"
                        placeholder="UKN"
                        value={values.UKN}
                        onChange={handleChange}
                        id="UKN"
                        // required
                        maxLength="50"

                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-3 col-sm-6 mt16 ">
                  <label
                    className="form-check-label fw-500 fs-14 mailing-checkbox-label "
                  >
                    <span className="maiden-link" onClick={() => handleCDCLink()}> CDC Access</span>  provides you the ability to verify transactions through a web portal or by calling the CDC helpline. To subscribe to CDC Access, please submit your mother's maiden name. This is a free and optional service.

                  </label>
                  <div className="row">
                    <div className="col-lg-8">
                      <label
                        htmlFor="MOTHER_MAIDEN_NAME"
                        className="col-12 col-form-label fw-500"
                      >
                        Mother's Maidan Name
                        <Tooltip overlayStyle={{ maxWidth: '658px' }} title={
                          <>
                            <p className="fw-500 fs14 text-white">
                              Your mother's maiden name is her name before marriage. Please remember your selection as this will be used as a security question on the CDC platform.
                            </p>
                          </>
                        }
                          placement="bottom"
                        >
                          <span className="ml10">
                            <HelpIcon />
                          </span>
                        </Tooltip>
                      </label>

                      <input
                        type="text"
                        name="MOTHER_MAIDEN_NAME"
                        className="form-control"
                        placeholder="Nusrat BiBi"
                        value={values.MOTHER_MAIDEN_NAME}
                        onChange={handleChange}
                        id="MOTHER_MAIDEN_NAME"
                        required={true}
                        maxLength="50"
                      />
                      {!values.MOTHER_MAIDEN_NAME ? <span id="mothermaidenname" className="text-danger fs10" style={{ display: "none" }} >Mother's Maiden Name Required</span> : ""}
                    </div>
                  </div>
                </div>
              </div>


              <hr className="t-grey-200 mt80"></hr>
              <div className="row mt-80">
                <Disclaimer />

                <div className="col-lg-5 col-xl-4 ">
                  <div className="text-end threeButton d-lg-flex justify-content-end">

                    <div className='px-2 d-lg-none mb-2'>
                      <button
                        className="btn-filled fs16 px-2 px-md-3 btnPad disableBtn naviBtn"
                        type="submit"
                        id="IDVerification"
                        // onClick={handleContinueSubmit}
                        disabled={backAndContinueBtnStatus == true}
                      >
                        {backAndContinueBtnStatus ? (

                          <div className="whitespinner">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                          </div>
                        ) : (
                          <>Continue</>
                        )}
                      </button>
                    </div>
                    <div className="d-flex mb-2 mb-lg-0">
                      <div className='px-2'>
                        <button
                          className="btn-outlined fs16 px-2 px-md-3 disableBtn btnPad"
                          type="button"
                          // onClick={() => handleDrctChange('step', 1)}
                          disabled={backAndContinueBtnStatus == true}
                          onClick={(e) => SaveOnBackSubmit(e, 'back')}
                        >
                          Back
                        </button>
                      </div>
                      <div className='px-2'>
                        <button
                          className="btn-outlined fs16 px-2 px-md-3 disableBtn btnPad"
                          type='button'
                          disabled={backAndContinueBtnStatus == true}
                          onClick={SaveSubmit}
                        >
                          {sendingSaveReq ? (
                            <div className="spinner">
                              <div className="bounce1"></div>
                              <div className="bounce2"></div>
                              <div className="bounce3"></div>
                            </div>
                          ) : (
                            <>Save & Exit</>
                          )}
                        </button>
                      </div>
                    </div>

                    <div className='px-2 d-none d-lg-block'>
                      <button
                        className="btn-filled fs16 px-2 px-md-3 btnPad disableBtn  naviBtn"
                        type="submit"
                        id='IDVerification2'
                        // onClick={handleContinueSubmit}
                        disabled={backAndContinueBtnStatus == true}
                      >
                        {backAndContinueBtnStatus ? (

                          <div className="whitespinner">
                            <div className="bounce1"></div>
                            <div className="bounce2"></div>
                            <div className="bounce3"></div>
                          </div>
                        ) : (
                          <>Continue</>
                        )}
                      </button>
                    </div>
                  </div>

                  {backAndContinueBtnStatus &&
                    <div className="text-end">

                      <p className="fw-400 fs14 t-grey-400 pt3">

                        Please wait while the documents upload

                      </p>
                    </div>
                  }

                  {errorMessage &&
                    <div className="text-end pt 3">

                      <p className="fw-400 fs14 t-red">

                        An unknown error has occurred

                      </p>
                    </div>

                  }
                </div>


                {/* <div className="col-lg-5 col-xl-4 text-end">
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type='button'
                    onClick={SaveSubmit}
                  >
                    {sendingSaveReq ? (
                      // <div className="spinner-border t-pink" role="status">
                      //   <span className="visually-hidden">Loading...</span>
                      // </div>
                      <div className="spinner">
                        <div className="bounce1"></div>
                        <div className="bounce2"></div>
                        <div className="bounce3"></div>
                      </div>
                    ) : (
                      <>Save & Exit</>
                    )}
                  </button>
                  <button
                    className="btn-outlined fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="button"

                    onClick={SaveOnBackSubmit}
                  >
                    Back
                  </button>
                  <button
                    className="btn-filled fs16 px-2 px-md-3 py-01 py-md-2 mx-2 naviBtn"
                    type="submit"
                    onClick={handleContinueSubmit}
                  >
                    Continue
                  </button>
                </div> */}


              </div>
            </form>
            <p className="text-danger fs12 text-end">{error}</p>
          </div>
          <div className="modal" tabIndex="-1" role="dialog" id="SaveExitModal">
            <div className="modal-dialog centerr" role="document">
              <div className="modal-content">
                <div className="modal-header p-0">
                  <h5 className="modal-title t-pink">Information Submited</h5>

                  <span className="close cross">&times;</span>
                </div>
                <div className="modal-body px-0">
                  {" "}
                  <p className="fw-500 fs16 ms-auto t-grey-400 cursorPointer">
                    Thank You your information has been saved.
                  </p>
                </div>
                <div className="modal-footer px-0">
                  <NavLink to="/Dashboard">
                    <button
                      type="button"
                      className="btn-outlined fs16 px-3 py-2 mx-2 close"
                      data-dismiss="modal"
                    // onClick={() => logout()}
                    >
                      OK
                    </button>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IDVerification;

const HelpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 15C9.45 15 9 14.55 9 14V10C9 9.45 9.45 9 10 9C10.55 9 11 9.45 11 10V14C11 14.55 10.55 15 10 15ZM11 7H9V5H11V7Z" fill="#D2D6DC" />
  </svg>

)
